import { useContext } from "react"
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Focus() {
  const { setFocus } = useContext(MultiContext)
  const onClick = ({ position }) => setFocus((focus) => (focus ? null : position))

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>Select a video to focus on</Panel.HeadingDescription>
      </Panel.Heading>
      <Panel.Layout Icon={ArrowsPointingOutIcon} onClick={onClick} />
    </Panel>
  )
}
